import { useMutation } from '@tanstack/react-query';

import { services } from '../../services';

export const useSendRemindersAutomation = (options = {}) =>
  useMutation(
    ({ code, orderCodes, subject }) =>
      services.sendReminder({
        params: { code },
        body: { orderCodes, subject }
      }),
    options
  );
